export default __webpack_public_path__ + "static/media/sarah.f870905b.webp";